import {State} from './state';

export class City {
    id:string;
    name:string;
    state:State = new State(null);
    completeName:string;

    constructor(other:City) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.state = other.state;
            this.completeName = this.name + (!this.state) ? '' : ' - ' + this.state.name;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/city.ts
 **/